import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// css modules to import: https://swiperjs.com/swiper-api#css-styles
import 'swiper/swiper.min.css';

new Vue({
  el: '#app',
  data() {
    return {
      partner: null,
      lang: document.documentElement.lang,
    };
  },
  mounted() {
    const allParts = window.location.href.split('/');
    const partnerSlug = allParts[allParts.length - 1];
    axios
      .get(`/api/partners?name=${partnerSlug}`)
      .then((response) => {
        this.partner = response.data[0];
        this.lang = document.documentElement.lang;
        this.$nextTick(() => {
          this.initializeSwiper(); // Initialize Swiper after DOM update
        });
      })
      .catch((error) => {
        console.log(error);
        this.partners = [];
      });
  },
  methods: {
    initializeSwiper() {
      this.$nextTick(() => {
        if (this.$refs.slider !== undefined) {
          const { slider } = this.$refs;
          const gap = 20;

          const swiperWrapper = slider.querySelector('.swiper-wrapper');
          const lastSwiperSlide = slider.querySelector(
            '.swiper-slide:last-of-type'
          );

          /**
           * Justify Left hack inspired by https://codepen.io/YUUMU/pen/KKMaxOZ?editors=1111
           * More info: https://github.com/nolimits4web/swiper/issues/7254#issuecomment-2255243227
           **/
          const swiperJustifyLeft = (swiper) => {
            const wrapperItemsGap = Math.max(
              slider.clientWidth - swiperWrapper.clientWidth + gap,
              0
            );

            swiper.params.slidesOffsetAfter =
              slider.clientWidth -
              lastSwiperSlide.clientWidth -
              wrapperItemsGap;
            swiper.update();
          };

          const swiper = new Swiper(slider, {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: gap,
            modules: [Navigation],
            grabCursor: true,
            speed: 800,
            navigation: {
              nextEl: slider.querySelector('.slider__btn--next'),
              prevEl: slider.querySelector('.slider__btn--prev'),
            },
            on: {
              init: (swiper) => {
                swiperJustifyLeft(swiper);
              },
              resize: (swiper) => {
                swiperJustifyLeft(swiper);
              },
            },
          });
        }
      });
    },
  },
});
